﻿﻿﻿<mat-spinner diameter="80"></mat-spinner>